import React, { useState } from 'react'
import styled from 'styled-components'
import poster from '../../images/booth/HyruanOnePoster.jpg'
import { SIZES } from '../../styles/theme'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const Wrapper = styled.div`
  position: fixed;
  left: 20%;
  bottom: 5%;
  width: 450px;
  z-index: 1000;
  #box {
    position: absolute;
    top: 13%;
    bottom: 82.5%;
    left: 39%;
    right: 39%;
    cursor: pointer;
  }
  button.close {
    position: absolute;
    font-size: 30px;
    transform: translateX(-150%);
    color: white;
    opacity: 1;
  }
  ${SIZES.mobile} {
    left: 0;
    bottom: 60px;
    width: 100%;
  }
`

function KioskPoster ({ showPoster, showModal }) {
  const [posterLoading, setPosterLoading] = useState(true)

  return (
    <Wrapper>
      <LazyLoadImage
        effect="black-and-white"
        afterLoad={() => setPosterLoading(false)}
        src={poster}
        width="100%"
        alt="poster"
        style={{ opacity: !posterLoading ? 1 : 0}}
      />
      <div id="box" onClick={showModal}></div>
      {!posterLoading && <button className="close" onClick={showPoster}>x</button>}
    </Wrapper>
  )
}

export { KioskPoster }